<template>
  <section id="testimonials" class="py-5 bg-light">
    <div class="container">
      <div class="text-center mb-5">
        <h2 class="fw-bold text-dark">Lo que dicen nuestros médicos</h2>
        <p class="mt-2 fs-5 text-muted">Opiniones de profesionales que ya usan Medicynia.</p>
      </div>
      <div id="testimonialCarousel" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-indicators">
          <button v-for="(testimonial, index) in testimonials" :key="`indicator-${index}`" type="button" :data-bs-target="'#testimonialCarousel'" :data-bs-slide-to="index" :class="{ active: index === 0 }" :aria-current="index === 0 ? 'true' : 'false'" :aria-label="`Testimonio ${index + 1}`"></button>
        </div>
        <div class="carousel-inner">
          <div v-for="(testimonial, index) in testimonials" :key="`item-${index}`" :class="['carousel-item', { active: index === 0 }]">
            <div class="row justify-content-center">
              <div class="col-lg-8">
                <div class="card border-0 bg-transparent">
                  <div class="card-body text-center">
                    <i class="bi bi-quote fs-1 text-primary mb-3"></i>
                    <p class="lead fst-italic mb-4">"{{ testimonial.comment }}"</p>
                    <h5 class="fw-bold text-dark mb-0">{{ testimonial.name }}</h5>
                    <p class="text-muted mb-0">{{ testimonial.specialty }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Anterior</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Siguiente</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TestimonialsSection',
  data() {
    return {
      testimonials: [
        { name: 'Dr. Alejandro Vargas', specialty: 'Cardiólogo', comment: 'Medicynia ha transformado la gestión de mis pacientes. La agenda es intuitiva y el acceso al historial clínico es inmediato. ¡Excelente herramienta!' },
        { name: 'Dra. Isabel Gutiérrez', specialty: 'Pediatra', comment: 'Me encanta la facilidad para generar notas médicas que cumplen con la NOM-004. Ahorro mucho tiempo y mis expedientes están siempre ordenados.' },
        { name: 'Dr. Ricardo Morales', specialty: 'Médico General', comment: 'El sistema es muy estable y fácil de usar. El soporte técnico respondió rápidamente a mis dudas iniciales. Lo recomiendo ampliamente.' },
        { name: 'Dra. Sofía Jiménez', specialty: 'Ginecóloga', comment: 'La función de consentimientos informados digitales es fantástica. Mis pacientes aprecian la modernidad y yo la seguridad jurídica que me brinda.' },
        { name: 'Dr. Fernando Ríos', specialty: 'Dermatólogo', comment: 'Poder adjuntar fotos y resultados de estudios directamente a la consulta del paciente es increíblemente útil para el seguimiento.' },
        { name: 'Dra. Laura Méndez', specialty: 'Endocrinóloga', comment: 'La configuración de horarios y tipos de consulta es muy flexible. Se adapta perfectamente a mi forma de trabajar, ya sea en consultorio o virtual.' },
        { name: 'Dr. Javier Castillo', specialty: 'Oftalmólogo', comment: 'Desde que uso Medicynia, la administración de mi consultorio es mucho más eficiente. Puedo dedicar más tiempo a mis pacientes.' },
        { name: 'Dra. Elena Torres', specialty: 'Psiquiatra', comment: 'La interfaz es limpia y muy profesional. Generar recetas y planes de tratamiento es sencillo y rápido. Muy satisfecha.' },
        { name: 'Dr. Miguel Ángel Ponce', specialty: 'Traumatólogo', comment: 'El resumen del historial clínico y los antecedentes me permite tener una visión completa del paciente en segundos. Fundamental para mi especialidad.' }
      ]
    }
  }
}
</script>

<style scoped>
.carousel-item {
  padding: 2rem 0; /* Add some vertical padding */
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  background-color: rgba(0, 0, 0, 0.5); /* Darker controls for better visibility */
  border-radius: 50%;
  padding: 1rem; /* Make controls slightly larger */
  background-size: 50% 50%; /* Adjust icon size within the background */
}

.carousel-indicators [data-bs-target] {
  background-color: var(--eb-primary); /* Use primary color for indicators */
}

.card-body i.text-primary {
  color: var(--eb-primary) !important; /* Ensure icon color */
}
</style>
